<script setup lang="ts">

definePageMeta({
  showMobileNavigation: true,
});

const currentOffer = useCurrentOfferState();
const { offerAPI } = useBackendRequests();
const housingId = idFromHousingUri();

if (!housingId) {
  throw createError({
    statusCode: 404,
    fatal: true,
  });
}

const { data: offer, error: offerError } = await useAsyncData('fetch-offer-data-for-offer-page', async () => {
  const offerResponse = await offerAPI.getByHousingId(housingId!);
  return offerResponse.offer;
});

const offerNotFound = ref(false);

if (offerError.value || offer.value === null) {
  offerNotFound.value = true;
} else {
  currentOffer.value = offer.value;
}
</script>

<template>
  <div>
    <tw-offer-error-not-found v-if="offerNotFound" :housing-id="housingId" />
    <tw-offer v-else />
  </div>
</template>

<style scoped lang="scss"></style>
